import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "meters-notification-card" }
const _hoisted_2 = { class: "meters-notification-card__title" }
const _hoisted_3 = { class: "meters-notification-card__subtitle" }
const _hoisted_4 = { class: "meters-notification-card__icon-wrap" }

import { useI18n } from 'vue-i18n';

import { useRouter } from 'vue-router';

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';
import SmSecondButton from '@/components/ui/buttons/SmSecondButton/SmSecondButton.vue';

import '@/components/common/SmMetersCard/style.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmMetersCard',
  props: {
    count: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const router = useRouter();

// [START] Props

// [END] Props

const handleOpenMetters = () => {
  router.push({ name: 'Meters' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('meters', props.count)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('pending')), 1),
    (props.count)
      ? (_openBlock(), _createBlock(SmSecondButton, {
          key: 0,
          onClick: handleOpenMetters
        }, {
          default: _withCtx(() => [
            _createTextVNode("Показать ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(SmIcon, {
        name: "Meter",
        class: "meters-notification-card__icon"
      })
    ])
  ]))
}
}

})